<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      class="createDeliveryBillDialog"
      :title="form.pkid ? '编辑' : '新建'"
      width="1500px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="form"
        :rules="ruleValidate"
        label-width="100px"
        :disabled="!edit">
      <el-row>
        <el-col :span="12">
          <el-form-item label="供应商编码">
            <el-input v-model="form.supplierNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商名称">
            <el-input v-model="form.supplierName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="直发标识">
            <el-select v-model="form.straightMark" :disabled="!straightAuth" clearable>
              <el-option
                  v-for="item in straightMarkList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预计到货日期" prop="plannedArrivalTime">
            <div class="clock">
              <el-date-picker
                  v-model="form.plannedArrivalTime"
                  value-format="yyyy-MM-dd 00:00:00"
                  style="width: 100%"
                  type="date"
                  placeholder="到达新时达的日期"/>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="送货单地址">
            <el-input v-model="form.purchaseReceiveAddress" placeholder="请输入送货单地址"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="寄售">
            <el-select v-model="form.consignment" disabled>
              <el-option label="寄售" :value="'寄售'"/>
              <el-option label="非寄售" :value="'非寄售'"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="form.note" placeholder="请输入备注"/>
          </el-form-item>
        </el-col>
        <el-col v-if="form.straightMark === 'Z002' " :span="12">
          <el-form-item label="发货单号" prop="deliveryNo">
            <el-input v-model="form.deliveryNo" placeholder="如有多个请用逗号隔开"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="送货方式" placeholder="请选择送货方式" prop="deliveryMethod">
            <el-select v-model="form.deliveryMethod">
              <el-option label="物流直发" :value="'物流直发'"/>
              <el-option label="跨越速运" :value="'跨越速运'"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="form.deliveryMethod!=='物流直发'" :span="12">
          <el-form-item label="快递单号" prop="trackingNumber">
            <el-input v-model="form.trackingNumber" placeholder="请输入快递单号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="直发信息" prop="straightMarkMessage">
            <span>{{form.straightMarkMessage}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button v-if="edit" type="primary" style="margin-bottom: 10px" @click="$refs.purchaseSelect.open(isYh)">
      新增
    </el-button>
    <el-table :data="form.receiveDetails" border show-summary :summary-method="getSummary">
      <el-table-column
          prop="urgent"
          align="center"
          label="标识"
          show-overflow-tooltip
          width="70"/>
      <el-table-column
          prop="evaluate"
          align="center"
          label="采购订单"
          show-overflow-tooltip
          width="100"/>
      <el-table-column prop="podetailRowNO" align="center" label="行号" width="80"/>
      <el-table-column
          prop="sapmaterialNO"
          align="center"
          label="物料编号"
          show-overflow-tooltip
          width="120"/>
      <el-table-column
          prop="mappingMaterialNo"
          align="center"
          label="旧物料号"
          show-overflow-tooltip
          width="120"/>
      <el-table-column
          prop="sapmaterialName"
          align="left"
          label="物料描述"
          min-width="120"
          show-overflow-tooltip/>
      <el-table-column
          prop="specification"
          align="left"
          label="规格型号"
          min-width="120"
          show-overflow-tooltip/>
      <el-table-column prop="sumQuantity" align="center" label="采购数量" width="70"/>
      <el-table-column prop="hasInStorageQty" align="center" label="入库数量" width="70"/>
      <el-table-column prop="sumReceiveQty" align="center" label="送货单数量" width="90"/>
      <el-table-column prop="quantity" align="center" label="送货数量" width="160">
        <template slot-scope="scope">
          <el-input-number
              v-model.trim="scope.row.quantity"
              placeholder="请输入"
              :disabled="!edit"
              :max="edit?scope.row.leftQty:99999999"
              :min="1"/>
        </template>
      </el-table-column>
      <el-table-column prop="location" align="center" label="仓储地点" width="120">
        <template slot-scope="scope">
          <el-select v-model="scope.row.location" placeholder="请选择" disabled>
            <el-option
                v-for="item in constants.locationNo.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="locationNo" align="center" label="库存仓位" width="150"/>
      <el-table-column
          v-if="edit"
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="80">
        <template slot-scope="scope">
          <el-button type="danger" @click="deleteRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="form.pkid>0">
      <div
          style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
        订单附件
      </div>
      <div
          style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
        <upload-file
            ref="upload"
            :auth-index="authIndex"
            style="margin-bottom: 10px; float: left"
            @upload-success="uploadSuccess"/>
      </div>
      <el-table
          v-if="form.accessoryList"
          ref="payData1"
          :data="form.accessoryList">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.fileName"
                class="tabInput"
                style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span v-if="edit" slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
    </span>
    <purchaseSelect ref="purchaseSelect" :selected-id="selectedId" @select="purchaseSelect"/>
  </el-dialog>
</template>

<script>
  import purchaseSelect from "../PurchaseOrder/PurchaseSelect.vue";
  import loginUtil from "@/util/loginUtil";
  import UploadFile from "@/components/UploadFile";
  import constants from "@/util/constants";

  export default {
    components: {UploadFile, purchaseSelect},
    props: {
      isYh: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        pkid: "",
        activeName: "deliverySlipInfo", // 当前标签页
        dialogVisible: false,
        uploadLoading: false,
        edit: false,
        straightAuth: this.$auth(284),
        authIndex: 284,
        imgUrls: [],
        constants,
        form: {
          pkid: "",
          supplierNo: "", // 供应商编码
          supplierName: "", // 供应商名称
          factoryName: "", // 工厂
          deliveryAddress: "", // 收货地址
          purchaseReceiveAddress: "",//送货单地址
          shipper: "", // 发货人
          straightMark: "",
          shipperPhone: "", // 发货人联系方式
          deliveryMethod: "物流直发", // 送货方式
          plannedArrivalTime: "", // 预计发货日期
          deliveryDate: "", // 预计到货日期
          note: "", // 备注
          receiveDetails: [], // 送货单明细
          accessoryList: [],
          deliveryNo: "",
          trackingNumber: "",
          consignment: "非寄售",//寄售
        },
        files: [],
        straightMarkList: [
          // {label: "按单直发客户", value: "Z001"},
          {label: "备库直发客户", value: "Z002"},
          {label: "发杭州工控", value: "1000"},
        ],
        ruleValidate: {
          plannedArrivalTime: {required: true, message: "请选择预计到货日期"},
          trackingNumber: {required: true, message: "请输入快递单号"},
          deliveryMethod: {required: true, message: "请选择送货方式"},
          deliveryNo: {required: true, message: "请输入发货单号"},
        },
        fileList: [],
        submitLoading: false,
      };
    },
    computed: {
      selectedId: {
        get() {
          const field = this.isYh ? "purchasePlanId" : "purchaseOrderDetailId";
          return this.form.receiveDetails.map(item=> item[field]);
        },
      },
    },
    methods: {
      open(pkid, selection, edit) {
        this.edit = edit;
        this.dialogVisible = true;
        this.pkid = pkid;
        if (pkid) {
          this.getData();
        } else {
          let newArr = [];
          selection.forEach((item) => {
            const obj = {
              evaluate: item.evaluate,
              podetailRowNO: item.rowNum,
              sapmaterialNO: item.partNo,
              sapmaterialName: item.partNameSpec,
              responseDeliveryTime: item.responseDeliveryTime,
              sapsaleOrderDetailRowIndex: item.sapsaleOrderDetailRowIndex,
              sumQuantity: item.qty,
              quantity: item.leftQty,
              leftQty:item.leftQty,
              hasInStorageQty: item.hasInStorageQty,
              supplierNo: item.supplierNo,
              pCorderNo: item.pCorderNo,
              shippingAddress: item.shippingAddress,
              supplierName: item.supplierName,
              purchaseDetailId: item.purchaseDetailId,
              purchaseOrderId: item.mastPKID,
              straightMark: item.straightMark,
              location: item.location,
              consignment: item.consignment,
              purchasePlanId: item.purchasePlanId,
              purchasePlanQty: item.purchasePlanQty,
              specification: item.specification,
              purchaseOrderDetailId:item.pkid,
              urgent:item.urgent,
              mappingMaterialNo:item.mappingMaterialNo,
              sumReceiveQty:item.sumReceiveQty,
            };
            newArr.push(obj);
          });
          this.form.receiveDetails = newArr;
          this.form.supplierNo = newArr[0].supplierNo;
          this.form.supplierName = newArr[0].supplierName;
          this.form.straightMark = newArr[0].straightMark;
          this.form.consignment = newArr[0].consignment;
          if (this.form.straightMark === "1000") {
            this.form.purchaseReceiveAddress = "杭州市余杭区闲林工业园闲兴路35号4号楼";
          }
        }
      },
      // 编辑查详情
      getData() {
        this.$http.get("basic", `purchaseReceives/getPurchaseReceiveById/${this.pkid}`).then((res) => {
          if (res.success) {
            this.form = res.data;
            this.form.accessoryList.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });
            });
          }
        });
      },
      //检测明细地址是否一致
      CheckAddress() {
        if (this.form.receiveDetails.length) {
          const addressListFalse = this.form.receiveDetails.filter((item) => item.shippingAddress !== this.form.receiveDetails[0].shippingAddress);
          const addressListTrue = this.form.receiveDetails.filter((item) => item.shippingAddress === this.form.receiveDetails[0].shippingAddress);
          const flag = this.form.receiveDetails.length / 2;
          const length = addressListFalse.length;
          if (0 < length && length < flag) {
            this.CheckAction(addressListFalse, addressListTrue);
          } else if (length >= flag) {
            this.CheckAction(addressListTrue, addressListFalse);
          } else {
            this.CheckAction("", this.form.receiveDetails);
          }
        } else {
          this.form.purchaseReceiveAddress = "";
        }
      },

      //地址检测处理
      CheckAction(messageList, infoList) {
        var message = "";
        if (messageList) {
          messageList.forEach((item) => {
            message += "采购单号:" + item.evaluate + "-物料号:" + item.sapmaterialNO + "-行项:" + item.podetailRowNO + "直发地址不一致！" + "<br/>";
          });
          this.form.purchaseReceiveAddress = "";
          this.$nextTick(() => {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: message,
              customClass: "messageBox",
              type: "error",
            });
          });
        }
        this.form.receiveDetails = infoList;
        this.form.purchaseReceiveAddress = this.form.receiveDetails[0].straightMark === "Z001" ? this.form.receiveDetails[0].shippingAddress : "杭州市余杭区闲林工业园闲兴路35号4号楼";
      },

      // 检测本次送货数量是否超出剩余发货数量
      checkQuantity(row) {
        const reg = /^[0-9]*[1-9][0-9]*$/;
        if (!reg.test(row.quantity)) {
          this.$confirm("请输入大于0的整数", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
        if (row.quantity > row.sumQuantity - row.hasInStorageQty) {
          this.$confirm("送货数量超出剩余发货数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
      },
      // 删除行项
      deleteRow(index) {
        this.form.receiveDetails.splice(index, 1);
        this.CheckAddress();
      },
      // 新增行项
      purchaseSelect(purchaselist) {
        console.log(purchaselist);
        console.log(this.form.receiveDetails);
        if (purchaselist) {
          var WrongEvaluateMessage = "";
          var WrongStraightMarkMessage = "";
          var WrongSupplierMessage = "";
          var WrrongAddressMessage = "";
          var WrongLocationMessage = "";
          var Message = "";
          for (let row of purchaselist) {
            console.log(row);
            const WrongEvaluate = this.form.receiveDetails.find((item) => item.evaluate === row.evaluate && item.podetailRowNO === row.rowNum);
            // const WrongStraightMark = row.straightMark !== this.form.straightMark;
            const WrongSupplier = this.form.receiveDetails.find((item) => item.supplierNo !== row.supplierNo);
            // const WrongAddress = this.form.purchaseReceiveAddress !== row.shippingAddress;
            // const WrongLocation = this.form.receiveDetails.find((item) => item.location !== row.location);
            // const WrongConsignment = this.form.consignment.find((item) => item.consignment !== row.consignment);
            // console.log("111");
            // if (WrongEvaluate || WrongStraightMark || WrongLocation || WrongConsignment) {
            if (WrongEvaluate) {
              WrongEvaluateMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "已存在，请勿重复添加" + "<br/>";
            }
            //   if (WrongStraightMark) {
            //     WrongStraightMarkMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "直发标识不一致，请重新选择" + "<br/>";
            //   }
            if (WrongSupplier) {
              WrongSupplierMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "供应商不一致，请重新选择" + "<br/>";
            }
            //   if (WrongLocation) {
            //     WrongLocationMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "仓位不一致，请重新选择" + "<br/>";
            //   }
            //   if (WrongConsignment) {
            //     WrongLocationMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "寄售类型不一致，请重新选择" + "<br/>";
            //   }
            // } else if (this.form.straightMark === "Z001" && WrongAddress) {
            //   WrrongAddressMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "直发地址不一致,请重新选择" + "<br/>";
            // }
            else {
              const obj = {
                evaluate: row.evaluate,
                podetailRowNO: row.rowNum,
                sapmaterialNO: row.partNo,
                sapmaterialName: row.partNameSpec,
                sapsaleOrderDetailRowIndex: row.sapsaleOrderDetailRowIndex,
                responseDeliveryTime: row.deliveryDate,
                sumQuantity: row.qty,
                hasInStorageQty: row.hasInStorageQty,
                quantity: row.leftQty,
                leftQty:row.leftQty,
                shippingAddress: row.shippingAddress,
                straightMark: row.straightMark,
                supplierNo: row.supplierNo,
                supplierName: row.supplierName,
                purchaseDetailId: row.pkid,
                purchaseOrderId: row.mastPKID,
                pCorderNo: row.pCorderNo,
                location: row.location,
                consignment: row.consignment,
                purchasePlanId: row.purchasePlanId,
                purchasePlanQty: row.purchasePlanQty,
                specification: row.specification,
                urgent:row.urgent,
                purchaseOrderDetailId:row.pkid,
                sumReceiveQty:row.sumReceiveQty,
              };
              this.form.receiveDetails.push(obj);
            }
          }
          //拼接所有报错信息
          Message = WrongEvaluateMessage + WrongStraightMarkMessage + WrongSupplierMessage + WrrongAddressMessage + WrongLocationMessage;
          if (Message !== "") {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: Message,
              type: "error",
              showCancelButton: false,
            });
          }
        } else {
          this.$message.error("请勾选需要添加的行项！");
        }
      },

      oneDelete(index) {
        this.form.accessoryList.splice(index, 1);
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            itemID: this.form.pkid,
          };
          this.$http.post("basic","purchaseReceives/uploadReceipt",params)
            .then((resp)=>{
              if (resp.success) {
                this.form.accessoryList.push(params);
              }
            });

        }
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        var pkid = {
          pkid: this.pkid,
        };
        this.$http
          .post("basic", "purchaseReceives/uploadReceipt", formData, pkid)
          .then((res) => {
            if (res.success) {
              this.uploadLoading = false;
              this.$message.success("上传成功");
              this.getData();
            }
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },

      download(row) {
        let data = {
          name: row.accessoryName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          console.log(res);
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },

      // 保存
      saveHandle() {
        this.submitLoading=true;
        const arr = this.form.receiveDetails.filter((item) => !item.quantity);
        if (arr.length) {
          this.$confirm("请输入本次送货数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.submitLoading = true;

        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.pkid) {
              console.log(this.form);
              this.$http
                .post("basic", "purchaseReceives/create", this.form)
                .then((res) => {
                  if (res.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "purchaseReceives/update", this.form)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
        this.submitLoading = false;
      },

      getSummary({ columns, data }) {
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.property === "sumQuantity" || column.property === "hasInStorageQty" || column.property === "purchasePlanQty" || column.property === "quantity") {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = "";
          }
        });
        return sums;
      },
    },
  };
</script>

<style>
.createDeliveryBillDialog .el-dialog__body {
  padding: 10px 20px;
}

.createDeliveryBillDialog .el-tabs__header {
  margin: 0 0 10px;
}

.messageBox {
  z-index: 9999 !important;
}
</style>
